module.exports = "/img/_/_/_/assets/images/creeper/book/rare//11.jpg?d841241d8b072b24755f139bc95c44c8";